<template>
  <div class="page">
    <loading v-show="show" />
    <page-header curr="rebate" />
    <div class="content-wrap">
      <div class="mian-stream">
        <load-data-limit
          url="/api/article/GetArticleList"
          :cache="listcache"
          :extData="extData"
        >
          <template slot="item" slot-scope="props">
            <small-card :item="props.item" />
          </template>
        </load-data-limit>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/header.vue";
import loadDataLimit from "@/components/loadDataLimit.vue";
import SmallCard from "./../../components/card/card.vue";
import { mapState } from "vuex";

export default {
  data: function () {
    return {
      listcache: process.env.NODE_ENV == "production" ? true : false,
      //折扣type为3
      extData: {
        type: 2,
      },
    };
  },
  components: {
    PageHeader,
    SmallCard,
    loadDataLimit,
  },
  computed: {
    show() {
      return this.$store.state.show;
    },
  },
};
</script>

<style lang="scss">
$IMAGES_PATH: "../../style/images/";
@import "./../../style/scss/app.scss";
</style>



// WEBPACK FOOTER //
// src/pages/rebate/app.vue